/* Core */
import { AjaxifyGrid, AjaxifyGrid_CoreInit, Carousel, Carousel_CoreInit, Accordion, Popup, Form, Form_CoreInit, Burger, Mobile, Header_CoreInit } from './core'
import Header from './modules/header'

AjaxifyGrid_CoreInit([
  {
    classSelector: 'grid--style--testimonials',
    afterUpdate: function(grid) {
      $('.grid--style--testimonials').each(function() {
        $(this).data('addElements')();
        $(this).closest('.ajax-load-more__wrapper').css('max-height', $(this).outerHeight() + 'px');
      })
    },
  }
])

Carousel_CoreInit([
  {
    classSelector: 'carousel--style--default',
    swiperOptions: {},
  },
  {
    classSelector: 'carousel--style--storytelling',
    swiperOptions: window.Carousel_Storytelling(),
  },
  {
    classSelector: 'carousel--style--overlay',
    swiperOptions: window.Carousel_Overlay(),
  },
  {
    classSelector: 'carousel--style--simple',
    swiperOptions: {},
  },
  {
    classSelector: 'carousel--style--business',
    swiperOptions: {},
  },
  {
    classSelector: 'carousel--style--infinite',
    swiperOptions: Object.assign({}, window.Carousel_Overlay(), {
      loopAdditionalSlides : 2,
      loop: true,
    }),
  },
  {
    classSelector: 'carousel--style--testimonials',
    swiperOptions: {
      loopAdditionalSlides : 2,
      loop: true,
    },
  },
  {
    classSelector: 'carousel--style--gallery',
    swiperOptions: {},
  },
  {
    classSelector: 'carousel--style--logo',
    swiperOptions: window.Carousel_SideArrows(),
  },
])

Form_CoreInit([
  {
    classSelector: 'builder-form',
    formOptions: {
      floating_labels: true,
    },
  },
  {
    classSelector: 'builder-form--exemple',
    formOptions: {},
  },
  {
    classSelector: 'builder-form--contact',
    formOptions: {},
  },
  {
    classSelector: 'builder-form--demande-devis',
    formOptions: {},
  },
])

Header_CoreInit()

$(function() {
  $.mlmi = {
    mobile: new Mobile(),
    scroll: $(window).ScrollEvents(),
  }

  /* Accordéons */
  Accordion.init()

  /* Popups */
  Popup.init()

  /* Fixed content */
  FixedContent_PluginInit()

  /* Lightbox */
  Lightbox_PluginInit()

  /* Post Share */
  PostShare_PluginInit()

  /* Header */
  Header.init()

  /* Header search */
  HeaderSearch_PluginInit()

  /* Video loop */
  VideoLoop_PluginInit()

  $(document).on('mousemove', function(e) {
    $('.swiper-button-prev, .swiper-button-next').each(function() {
      $(this).css({
        '--left': (e.clientX - $(this).offset().left) + 'px',
        '--top': (e.clientY - $(this).offset().top + $(window).scrollTop()) + 'px',
      })
    })
  });

  $('.col > .grid--style--testimonials, .ajax-load-more__wrapper > .grid--style--testimonials').each(function() {
    $(this).Masonry({
      600: 1,
      800: 2,
    });
  })

  $('.bg-video').each(function() {
    $(this).VideoBg();
  })

  $('.row.row-stairs').each(function() {
    $(this).stairsEffect();
  });

  $('.custom-layout__image').each(function() {
    $(this).parallax(-.05)
  })

  $('.custom-layout__content').each(function() {
    $(this).parallax(.05)
  })

  $('.btn-primary, .btn-secondary, .secondary-menu__link, .field__submit').each(function() {
    $(this).html('<span>' + $(this).html() + '</span>');
  })

  $('.text-content a[class*=btn-]').each(function() {
    if ($(this).parent().is('p')) {
      if ($(this).parent().children().length === $(this).parent().find('a[class*=btn-]').length) {
        $(this).parent().contents().wrapAll('<div class="btn-wrapper"></div>');
      }
    }
  })

  /* Scroll to anchors */
  $('a[href^=#]:not([href$=#])').each(function() {
    $(this).scrollToAnchor()
  })
})
